import React from 'react';
import PropTypes from 'prop-types';
import { useCurrentLanguage } from 'tradera-lang/translate';
import { formatPrice } from 'tradera-utils/format';
import { useSelector } from 'react-redux';
import { selectPreferredCurrency } from 'tradera-state/multi-currency/selectors';

const MultiCurrency = ({
    amountInSek,
    className,
    tagName: TagName,
    style,
    prefix,
    allowNegative
}) => {
    const { language } = useCurrentLanguage();
    const preferredCurrency = useSelector(selectPreferredCurrency);

    const isVisible =
        preferredCurrency &&
        preferredCurrency.code !== 'SEK' &&
        amountInSek &&
        (amountInSek * preferredCurrency.rate > 0 || allowNegative);

    if (!isVisible) {
        return null;
    }

    const formattedPrice = formatPrice(
        amountInSek * preferredCurrency.rate,
        language,
        {
            currency: preferredCurrency.code,
            maximumFractionDigits: preferredCurrency.decimals
        }
    );
    return (
        <TagName className={`notranslate ${className}`} style={style}>
            {prefix || <>&asymp;</>}&nbsp;{formattedPrice}
        </TagName>
    );
};

MultiCurrency.propTypes = {
    amountInSek: PropTypes.number.isRequired,
    className: PropTypes.string,
    tagName: PropTypes.string,
    style: PropTypes.string,
    prefix: PropTypes.string,
    allowNegative: PropTypes.bool
};

MultiCurrency.defaultProps = {
    tagName: 'span'
};

export default MultiCurrency;
